import { lazy } from "react";
import { useContainer } from "./model/useContainer.js";
const widget = {
  useContainer,
  // @ts-ignore
  component: lazy(() => import("./ui/index.js").then((module) => ({ default: module.Button })))
};
export {
  useContainer,
  widget
};
